import { BaseChartAPIProps } from '~/types/create.types';

import { zoom } from '../zoom/zoom';

export interface TimeScaleReturn {
  zoomTime: (zoomScale: number) => void;
  barSpacing: number;
}

// TODO maybe replaced as a gesture handler if timescale is not appropriate as more is added
export const timescaleModel = (base?: BaseChartAPIProps): TimeScaleReturn => {
  let barSpacing = 0;
  let oldZoomScale = 0;

  const zoomTime = (zoomScale: number) => {
    if (oldZoomScale === zoomScale) {
      return;
    }
    oldZoomScale = zoomScale;
    const spacing = zoom(zoomScale, barSpacing, base);
    if (spacing) {
      barSpacing = spacing;
    }
  };

  return { zoomTime, barSpacing };
};
